import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "@/components/utils";

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "bg-muted text-muted-foreground inline-flex min-h-[50px] max-w-full items-center justify-start overflow-x-auto rounded-xl p-2",
      className,
    )}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef(
  ({ className, variant = "default", ...props }, ref) => (
    <TabsPrimitive.Trigger
      ref={ref}
      className={cn(
        "text-md ring-offset-background focus-visible:ring-ring inline-flex h-full cursor-pointer items-center justify-center gap-4 rounded-lg px-6 py-4 font-semibold whitespace-nowrap transition-all focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50",
        "via-background/80 hover:text-foreground from-transparent to-transparent hover:bg-gradient-to-r",
        "data-[state=active]:bg-background data-[state=active]:text-black data-[state=active]:shadow-sm",
        // variant styles:
        {
          "border-l-4 [&:not(:first-child)]:ml-2": variant !== "default",
          "border-destructive": variant === "destructive",
          "border-primary": variant === "primary",
          "border-success": variant === "success",
          "border-warning": variant === "warning",
        },
        className,
      )}
      {...props}
    />
  ),
);
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "ring-offset-background focus-visible:ring-ring hidden overflow-x-hidden focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden data-[state=active]:flex",
      className,
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
